import { AgentTurnType } from 'ui-product-approvals-common/types/ApprovalData';
import { ACTOR } from '../constants/actors';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import unescapedText from 'I18n/utils/unescapedText';
import formatName from 'I18n/utils/formatName';
export const actorToApprovalUser = (actor, usersRecord, agentsRecord, teamsRecord = {}) => {
  const {
    actorType,
    id
  } = actor;
  if (typeof actorType === 'symbol') {
    return {
      actor: {
        actorType: ACTOR.USER,
        id
      },
      displayName: `${unescapedText('productApprovals.actor.unknownName')} (${id})`,
      email: ''
    };
  }
  switch (actorType) {
    case ACTOR.USER:
      {
        var _user$email, _user$firstName, _user$lastName;
        const userId = Number(id);
        const user = usersRecord[userId];
        const email = (_user$email = user === null || user === void 0 ? void 0 : user.email) !== null && _user$email !== void 0 ? _user$email : '';
        const firstName = (_user$firstName = user === null || user === void 0 ? void 0 : user.firstName) !== null && _user$firstName !== void 0 ? _user$firstName : '';
        const lastName = (_user$lastName = user === null || user === void 0 ? void 0 : user.lastName) !== null && _user$lastName !== void 0 ? _user$lastName : '';
        return {
          actor: {
            actorType: ACTOR.USER,
            id
          },
          displayName: formatName({
            firstName,
            lastName,
            email
          }) || `${unescapedText('productApprovals.user.unknownName')} (${id})`,
          email
        };
      }
    case ACTOR.AGENT:
      {
        var _agentsRecord$id$disp, _agentsRecord$id;
        return {
          actor: {
            actorType: ACTOR.AGENT,
            id
          },
          displayName: (_agentsRecord$id$disp = (_agentsRecord$id = agentsRecord[id]) === null || _agentsRecord$id === void 0 ? void 0 : _agentsRecord$id.displayName) !== null && _agentsRecord$id$disp !== void 0 ? _agentsRecord$id$disp : id,
          email: ''
        };
      }
    case ACTOR.TEAM:
      {
        var _teamsRecord$id;
        const teamName = (_teamsRecord$id = teamsRecord[id]) === null || _teamsRecord$id === void 0 ? void 0 : _teamsRecord$id.name;
        const fallbackName = unescapedText('productApprovals.team.defaultName');
        return {
          actor: {
            actorType: ACTOR.TEAM,
            id
          },
          displayName: teamName !== null && teamName !== void 0 ? teamName : `${fallbackName} (${id})`,
          email: ''
        };
      }
    default:
      return unreachableFallback(actorType, {
        actor: {
          actorType,
          id
        },
        displayName: `${unescapedText('productApprovals.actor.unknownName')} (${id})`,
        email: ''
      });
  }
};
const resolveActedByDisplayName = (actedByUserId, usersRecord) => {
  var _user$firstName2, _user$lastName2, _user$email2;
  if (actedByUserId == null) {
    return undefined;
  }
  const user = usersRecord[actedByUserId];
  if (!user) {
    return undefined;
  }
  return formatName({
    firstName: (_user$firstName2 = user.firstName) !== null && _user$firstName2 !== void 0 ? _user$firstName2 : '',
    lastName: (_user$lastName2 = user.lastName) !== null && _user$lastName2 !== void 0 ? _user$lastName2 : '',
    email: (_user$email2 = user.email) !== null && _user$email2 !== void 0 ? _user$email2 : ''
  }) || undefined;
};
export const toApprovalData = (approvalResponse, usersRecord, agentsRecord, approvalType, approvalAction, teamsRecord = {}) => {
  var _approvalResponse$app, _approvalResponse$req, _approvalResponse$can, _approvalResponse$due, _approvalResponse$app2;
  return {
    id: approvalResponse.id,
    portalId: approvalResponse.portalId,
    title: approvalResponse.title,
    createDateTimestamp: approvalResponse.createDateTimestamp,
    approvalStatus: approvalResponse.approvalStatus,
    approvalType,
    approvalAction,
    approvalRules: approvalResponse.approvalRules,
    requester: actorToApprovalUser(approvalResponse.requester, usersRecord, agentsRecord, teamsRecord),
    approvalSteps: ((_approvalResponse$app = approvalResponse.approvalSteps) !== null && _approvalResponse$app !== void 0 ? _approvalResponse$app : []).map(step => {
      var _step$availableOperat, _step$approvedNote, _step$changesRequeste, _step$rejectionNote;
      return {
        id: step.id,
        order: step.order,
        actedByDisplayName: resolveActedByDisplayName(step.actedByUserId, usersRecord),
        approver: actorToApprovalUser(step.approver, usersRecord, agentsRecord, teamsRecord),
        approvalStepStatus: step.approvalStepStatus,
        availableOperations: (_step$availableOperat = step.availableOperations) !== null && _step$availableOperat !== void 0 ? _step$availableOperat : [],
        inProgressTurnType: step.inProgressTurnType === AgentTurnType.REVIEW || step.inProgressTurnType === AgentTurnType.APPLY_CHANGES ? step.inProgressTurnType : undefined,
        createDateTimestamp: step.createDateTimestamp,
        approvedNote: (_step$approvedNote = step.approvedNote) !== null && _step$approvedNote !== void 0 ? _step$approvedNote : '',
        changesRequestedNote: (_step$changesRequeste = step.changesRequestedNote) !== null && _step$changesRequeste !== void 0 ? _step$changesRequeste : null,
        rejectionNote: (_step$rejectionNote = step.rejectionNote) !== null && _step$rejectionNote !== void 0 ? _step$rejectionNote : null
      };
    }),
    requestNote: (_approvalResponse$req = approvalResponse.requestNote) !== null && _approvalResponse$req !== void 0 ? _approvalResponse$req : '',
    cancelNote: (_approvalResponse$can = approvalResponse.cancelNote) !== null && _approvalResponse$can !== void 0 ? _approvalResponse$can : null,
    cancelNoteTimestamp: null,
    dueDate: (_approvalResponse$due = approvalResponse.dueDate) !== null && _approvalResponse$due !== void 0 ? _approvalResponse$due : null,
    approvalConcluded: Boolean(approvalResponse.approvalConcluded),
    approvalConclusionReason: (_approvalResponse$app2 = approvalResponse.approvalConclusionReason) !== null && _approvalResponse$app2 !== void 0 ? _approvalResponse$app2 : null
  };
};